import { forwardRef, useCallback } from 'react';
import { SuggestionKeyDownProps } from '@tiptap/suggestion';
import { Icon } from 'Components/UI';
import Ellipsis from 'Components/UI/Ellipsis';
import AvatarsItems from 'Pages/Activities/components/AvatarsItems';
import { getTypeIcon } from 'Utils/ObraUtils';
import { SuggestionPropsType } from '../../activitySuggestion';
import {
  DropdownMenu,
  EmptyContent,
  Footer,
  MainContent,
  Status
} from './styles';

export interface MentionListActivityRef {
  onKeyDown: (props: SuggestionKeyDownProps) => boolean;
}

const MentionListActivity = forwardRef<MentionListActivityRef, SuggestionPropsType>((props, ref) => {
  const selectItem = useCallback((index: number) => {
    const item = props?.items[index];

    if (item) {
      props?.command({ id: item.Guid as string })
    }
  }, [props]);

  return (
    <DropdownMenu>
      {props?.items?.length ? (
        <MainContent>
          {props?.items?.map((item, index) => (
            <button
              className="item"
              key={index}
              onMouseDown={(e) => {
                e.preventDefault();
                selectItem(index);
              }}
            >
              <div className="left">
                <Icon
                  icon={getTypeIcon(item.Type?.Name || '')}
                  customSize={14}
                  className="activityIcon"
                />
                <span className="LeftContentIdentifier">
                  {`#${item.Identifier}`}
                </span>
                <Ellipsis
                  phrase={item.Title}
                  maxLength={25}
                  className="LeftContentTitle"
                />
              </div>
              <div className="right">
                <Status
                  bgColor={`${item.Status.Color}26`}
                  textColor={`${item.Status.Color}`}
                >
                  {item.Status.Name}
                </Status>
                <AvatarsItems
                  users={item.TopicAssignedUsers}
                  customMarginTop="-10px"
                  moreCustomMarginTop="-6px"
                  hideTooltip
                  inverse
                />
              </div>
            </button>
          ))}
        </MainContent>
      ) : (
        <EmptyContent>
          <Icon icon="person" customSize={16} className="iconEmpty" />
          <span className="textEmpty">Nenhuma atividade encontrada</span>
        </EmptyContent>
      )}
      <Footer>
        <span className="textFooter">'#' para Atividades</span>
      </Footer>
    </DropdownMenu>
  )
})

export default MentionListActivity;
